import React, { useState } from "react";
import { css } from "../../../styled-system/css";
import Card from "components/core/basic/Card";
import DOMPurify from "dompurify";
import Tabs from "components/core/basic/Tabs";

type Note = {
  note_id: string;
  body: string;
};

type Task = {
  task_id: string;
  subject: string;
  body: string;
};

type Reviews = {
  response: string;
  messages: string;
};

interface NoteCardProps {
  content: string;
  notes: Note[];
  tasks: Task[];
  reviews: Reviews[];
}

type tab = "content" | "notes" | "tasks" | "reviews";

function NoteCard({ content, notes, tasks, reviews }: NoteCardProps) {
  const [selectedTab, setSelectedTab] = useState<tab>("content");
  const tabs = {
    content: (
      <fieldset>
        <legend className={css({ color: "trellisPalette.13", fontWeight: "bold" })}>Description</legend>
        <p>{content}</p>
      </fieldset>
    ),
    notes:
      notes.length === 0 ?
        <p> No Notes Available</p>
      : <fieldset>
          <legend className={css({ color: "trellisPalette.13", fontWeight: "bold" })}>Notes</legend>
          <ol className={css({ "& li::marker": { color: "#999", fontSize: "16px" } })}>
            {notes.map((note) => (
              <li key={note.note_id}>
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(note.body) }} />
              </li>
            ))}
          </ol>
        </fieldset>,
    tasks:
      tasks.length === 0 ?
        <p> No Tasks Available</p>
      : <fieldset>
          <legend className={css({ color: "trellisPalette.13", fontWeight: "bold" })}>Tasks</legend>
          <ol className={css({ "& li::marker": { color: "#999", fontSize: "16px" } })}>
            {tasks.map((task) => (
              <li key={task.task_id}>
                <p>
                  <span className={css({ color: "trellisPalette.13", fontSize: "large", fontWeight: "medium" })}>
                    Subject:{" "}
                  </span>
                  {task.subject}
                </p>
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(task.body) }} />
              </li>
            ))}
          </ol>
        </fieldset>,
    reviews:
      reviews.length === 0 ?
        <p>Not Available</p>
      : <div>
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(reviews[0]?.response || "") }} />
        </div>,
  };
  return (
    <Card>
      <Tabs
        tabs={[
          {
            label: <span>Content</span>,
            key: "content",
          },
          {
            label: <span>Notes</span>,
            key: "notes",
          },
          {
            label: <span>Tasks</span>,
            key: "tasks",
          },
          {
            label: <span>Weekly Review</span>,
            key: "reviews",
          },
        ]}
        selectedTab={selectedTab}
        onTabChange={(tab) => setSelectedTab(tab as tab)}
      >
        {tabs[selectedTab]}
      </Tabs>
    </Card>
  );
}

export default NoteCard;
